module.exports = __webpack_public_path__ + "static/img/成四-張文吉.a1660cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成四-張文吉.jpg
// module id = VNfj
// module chunks = 1